import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import Button from '@material-ui/core/Button';

import { TextFieldComponent } from 'app/components/TextFieldComponent/TextFieldComponent';
import { CustomDialog } from 'app/components/CustomDialog/CustomDialog';

import { useStyles } from './AddFactoryModal.styles';
import { AddFactoryFormDataInterface, AddFactoryModalProps } from './AddFactoryModal.interfaces';
import { FactoryInterface } from 'app/shared/interfaces/Factory.interface';
import { FactoryService } from 'app/services/factory.service';
import { handlingCatch } from 'app/shared/helpers/handlingCatch';

export function AddFactoryModal({ isOpen, factoryData, onClose, factoryAdded }: AddFactoryModalProps) {
  const classes = useStyles();
  const initialValues: AddFactoryFormDataInterface = {
    name: factoryData ? factoryData.name : '',
    description: factoryData && factoryData.description ? factoryData.description : '',
  };
  const validationShema = Yup.object().shape({
    name: Yup.string().required('Podaj nazwę'),
  });

  return (
    <CustomDialog
      title={factoryData ? 'Edytowanie fabryki' : 'Dodawanie fabryki'}
      onCloseDialog={onClose}
      body={
        <Formik
          initialValues={initialValues}
          validationSchema={validationShema}
          onSubmit={(values, actions) => {
            const data: Omit<FactoryInterface, 'id' | 'factoryResources'> = {
              name: values.name.trim(),
              description: values.description,
            };

            if (factoryData) {
              FactoryService.replaceFactory(factoryData.id, data)
                .then(() => {
                  factoryAdded();
                })
                .catch((error) => {
                  const response = handlingCatch(error.response);
                  actions.setFieldError(response.fieldError, response.message);
                });
            } else {
              FactoryService.addFactory(data)
                .then(() => {
                  factoryAdded();
                })
                .catch((error) => {
                  const response = handlingCatch(error.response);
                  actions.setFieldError(response.fieldError, response.message);
                });
            }
          }}
        >
          {({ submitForm }) => (
            <Form>
              <Field component={TextFieldComponent} name={'name'} label={'Nazwa'} fullWidth />
              <Field
                component={TextFieldComponent}
                name={'description'}
                label={'Opis'}
                multiline
                rowsMax={4}
                fullWidth
              />
              <div className={classes.actionButtons}>
                <Button color={'primary'} onClick={submitForm}>
                  {factoryData ? 'Zapisz' : 'Dodaj'}
                </Button>
                <Button color={'primary'} autoFocus onClick={onClose}>
                  Anuluj
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      }
      isOpen={isOpen}
    />
  );
}
